import { useEffect, useRef } from "react";

import { ChatMessageBubble } from "./ChatMessageBubble";
import { ChatThinking } from "./ChatThinking";

export const ChatMessages = ({ messages, loading }) => {
    const bottomRef = useRef(null);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
    }, [messages, loading]);

    return (
        <div className="flex flex-1 flex-col gap-5 px-4 py-5 overflow-y-auto bg-cm-p-background">
            {messages.map((message, index) => (
                <ChatMessageBubble key={index} role={message.role} text={message.text} />
            ))}
            {loading ? <ChatThinking /> : null}
            <div ref={bottomRef} />
        </div>
    );
};
